import ffs from "@cloudbreakus/featurebang"
const { config } = ffs
import baseConfig from "config.json"

config.initialize(baseConfig)

export { config }
